/**
 * Форматирует URL изображения
 * @param {string} imagePath - путь к изображению или полный URL
 * @returns {string} - корректный URL изображения
 */
export const formatImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  if (imagePath.includes('https://api.alfateam.studio')) {
    const regex = /https?:\/\/api\.alfateam\.studio(https?:\/\/.*)/;
    const match = imagePath.match(regex);
    
    if (match && match[1]) {
      return match[1];
    }
  }
  
  const httpDuplicationRegex = /(https?:\/\/[^\s]*)(https?:\/\/)/;
  const duplicationMatch = imagePath.match(httpDuplicationRegex);
  
  if (duplicationMatch && duplicationMatch[2]) {
    const fullSecondUrl = imagePath.substring(imagePath.indexOf(duplicationMatch[2]));
    return fullSecondUrl;
  }
  
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  return imagePath;
};
